export default {
  // Navigation
  'home': "ಮುಖ್ಯಪುಟ",
  "detailed": "ವಿಸ್ತೃತ ಜೀವನ ವರದಿ",
  "about": "ನಮ್ಮ ಬಗ್ಗೆ", 
  "contact": "ಸಂಪರ್ಕಿಸಿ",
  "get_reading": "ವಾಚನ ಪಡೆಯಿರಿ",
  "unlock_destiny": "ನಿಮ್ಮ ಭಾಗ್ಯವನ್ನು ಬಿಚ್ಚಿಡಿ",
  "language": "ಭಾಷೆ",
  
  // Core Horoscope
  "core_horoscope": "ಮೂಲ ಜಾತಕ",
  "birth_chart": "ಜನ್ಮ ಕುಂಡಲಿ / ಜಾತಕ",
  "match_kundli": "ಕುಂಡಲಿ ಮಿಲನ",
  "ascendant_analysis": "ಲಗ್ನ ವಿಶ್ಲೇಷಣೆ",
  "gochar_phal": "ಗೋಚರ ಫಲ",
  "dasha_analysis": "ದಶಾ ಫಲ ವಿಶ್ಲೇಷಣೆ",
  "nakshatra_report": "ನಕ್ಷತ್ರ ವರದಿ",
  "numerology": "ಸಂಖ್ಯಾಶಾಸ್ತ್ರ",
  
  // Life Predictions
  "life_predictions": "ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳು",
  "your_life_predictions": "ನಿಮ್ಮ ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳು",
  "2025_report": "೨೦೨೫ ವೈಯಕ್ತಿಕ ವರದಿ",
  "year_analysis": "ವರ್ಷದ ವಿಶ್ಲೇಷಣೆ",
  "daily_horoscope": "ಇಂದಿನ ನನ್ನ ದಿನ",
  "love_compatibility": "ನಿಮ್ಮ ಪ್ರೇಮ ಜೀವನ",
  "career_guidance": "ವೃತ್ತಿ ಮಾರ್ಗದರ್ಶನ",
  "nature_analysis": "ನಿಮ್ಮ ನಿಜವಾದ ಸ್ವಭಾವ",
  "health_index": "ಆರೋಗ್ಯ ಸೂಚ್ಯಂಕ",
  
  // Remedial Solutions
  "remedial_solutions": "ಪರಿಹಾರ ಪರಿಹಾರಗಳು",
  "lal_kitab": "ಲಾಲ್ ಕಿತಾಬ್ ಜಾತಕ",
  "mangal_dosha": "ಮಂಗಳ ದೋಷ ವಿಶ್ಲೇಷಣೆ",
  "kalsarp_dosh": "ಕಾಲಸರ್ಪ ದೋಷ ವರದಿ",
  "sade_sati": "ಸಾಡೆ ಸಾತಿ ಜೀವನ ವರದಿ",
  "ask_question": "ಪ್ರಶ್ನೆ ಕೇಳಿ",
  "gemstones_report": "ರತ್ನಗಳ ವರದಿ"
};
